// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__IP45c","error":"Textarea_error__Q8XsD","readonly":"Textarea_readonly__1fkVG","disabled":"Textarea_disabled__3DReu"};